import { Button, Fade, Grid, Paper, Typography } from "@mui/material"
import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"
import Typewriter from "typewriter-effect"
import { useSfxAPI } from "../../sfx/context/SfxProvider"
import { useDialogAPI, useDialogData } from "../context/DialogProvider"

const DialogText: FC = () => {
  console.info("DialogsText render")

  //  CONTEXTS
  const { t } = useTranslation()
  const { currentTextKey } = useDialogData()
  const { nextDialog } = useDialogAPI()
  const { play } = useSfxAPI()

  //  LOGIC
  const typewriter = useMemo(() => {
    return (
      <Typewriter
        options={{
          strings: [t(`dialogs.${currentTextKey}`)],
          autoStart: true,
          loop: false,
          delay: 1,
          cursor: "",
          deleteSpeed: 6000000,
        }}
      />
    )
  }, [currentTextKey, t])

  //  CALLBACKS
  const handleClick = () => {
    nextDialog()

    play("clickLow")
  }

  return (
    <Fade
      in={true}
      timeout={500}
      style={{ transitionDelay: "100ms" }}
      unmountOnExit
    >
      <Paper variant="dialog">
        <Grid
          container
          spacing={4}
          justifyContent="flex-end"
          alignItems="end"
          sx={{
            flexWrap: { xs: "wrap", lg: "nowrap" },
          }}
        >
          <Grid
            item
            xs={8}
            lg={7}
            sx={{ position: "relative" }}
            alignItems="center"
          >
            <Typography
              // textAlign="justify"
              variant="dialog"
              sx={{ color: "transparent" }}
            >
              {t(`dialogs.${currentTextKey}`)}
            </Typography>
            <Typography
              // textAlign="justify"
              variant="dialog"
              sx={{ position: "absolute", top: "1em", left: 0 }}
            >
              {typewriter}
            </Typography>
          </Grid>
          <Grid item xs={9} lg={2} display="flex" justifyContent="flex-end">
            <Button onClick={handleClick}>{t(`ui.button.next`)}</Button>
          </Grid>
        </Grid>
      </Paper>
    </Fade>
  )
}

export default DialogText
